// eslint-disable-next-line eag/match-named-export
export const ORIGINAL_BACKGROUND_REMOVAL_IDS = ['49716', '61155', '79610', '12560'];
export const MERCEDES_BACKGROUND_REMOVAL_IDS = ['64169', '13206'];
export const MERCEDES_BACKGROUND_ZIZAK_REMOVAL_IDS = ['18363', '48525'];
export const MERCEDES_BACKGROUND_VSP_REMOVAL_IDS = ['13680', '82615'];
export const DAVOCAR_BACKGROUND_REMOVAL_IDS = ['82554', '68441'];
export const SWAUTOMOBILY_BACKGROUND_REMOVAL_IDS = ['49850', '36871', '75408', '13259'];
export const VSP_BACKGROUND_REMOVAL_IDS = ['21321', '42595'];
export const DISABLE_LICENSE_PLATE_REMOVAL_BACKGROUND_IDS = [
  ...MERCEDES_BACKGROUND_REMOVAL_IDS,
  ...MERCEDES_BACKGROUND_ZIZAK_REMOVAL_IDS,
  ...MERCEDES_BACKGROUND_VSP_REMOVAL_IDS,
  ...SWAUTOMOBILY_BACKGROUND_REMOVAL_IDS,
];
